<div class="text-center">
  <h5 class="text-lg font-normal mb-0">{{'ADMIN.TRIAL.NO_TRIAL' | translate}}</h5>
  <button   (click)="addTrail()" pButton pRipple type="button" icon="fa fa-plus" [label]="'TRIAL.CREATE' | translate" class="surface-0 p-button-outlined text-sm my-3"></button>
  <div><img src="/assets/img/trial-empty-img.svg" alt="Sorry! No trials configured!" /></div>
